
/**
 * Password size.
 */

const passwordSize = '.{8,}';

/**
 * Password number.
 */

const passwordNumber = '.*\\d';

/**
 * Password lowercase.
 */

const passwordLowercase = '.*[a-z]';

/**
 * Password uppercase.
 */

const passwordUppercase = '.*[A-Z]';

/**
 * Export `password`.
 */

export const password = `^.*(?=${passwordSize})(?=${passwordNumber})(?=${passwordLowercase})(?=${passwordUppercase}).*$`;

/**
 * Export `passwordRequirements`.
 */

export const passwordRequirements = {
  lowercase: passwordLowercase,
  number: passwordNumber,
  size: passwordSize,
  uppercase: passwordUppercase
};

/**
 * Export `slug`.
 */

export const slug = '^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$';

/**
 * Export `uuid`.
 */

export const uuid = '[0-9a-fA-F]{8}\\-[0-9a-fA-F]{4}\\-[0-9a-fA-F]{4}\\-[0-9a-fA-F]{4}\\-[0-9a-fA-F]{12}';

/**
 * Export `emailAddress`.
 */

export const emailAddress = '.+@[^@]+\\.[^@]{2,}$';
